module.exports = __webpack_public_path__ + "img/PRC_282010002.ASM.8644bad8.webp";